// import React from 'react';

function Show(props) {
  const { when, children } = props;
  return when ? children : null;
}

export default Show;
